<app-modal-header>
  <div translate class="ml-2 text-lg font-semibold text-theme-700" translate>menu.trilhas-aprendizagem</div>
</app-modal-header>
<div app-modal-content class="h-full w-full !p-0">
  <ngx-doc-viewer class="h-full" [url]="data?.url ?? data?.file" [viewer]="viewer(data?.extensao)"> </ngx-doc-viewer>
</div>
